const OrderDateFormatter = (params) => {
    const { value } = params;
    const date = new Date(value);
    return date.toLocaleDateString('en-US');
}

export default OrderDateFormatter;